import OrganizationalAuctionJSON from "./OrganizationAuction.json"

const contract = require("@truffle/contract")

export default contract({
  abi: OrganizationalAuctionJSON.abi,
})
